import React from 'react'
import { connect } from 'react-redux'
import { Button, Card, Popconfirm, Table, Tag, message } from 'antd'
import PageHeader from '@/components/PageHeader'
import Permission from '@/components/PermissionA5'
import { Search, SelectC } from '@/i2antdV5'
import { renderMoney, renderTextStr } from '@/utils/renderUtils'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchTuinaProjectList } from '@/redux/tuina/projectListSlice'
import { updateTuinaProjectStatus } from '@/service/tuina'
import { TUINA_PROJECT_STATUS_OPTIONS } from './mockProjects'
import ProjectModal from './share/ProjectModal'
import PurchaseOrderModal from './share/PurchaseOrderModal'
import './Page.less'

const breadcrumbList = [
  { breadcrumbName: '按摩' },
  { breadcrumbName: '服务项目' }
]

/** 列表默认查询（仅页面侧使用，不写入 Redux initialState） */
const DEFAULT_TUINA_PROJECT_LIST_QUERY = {
  pageNumber: 1,
  pageSize: 20,
  status: 'on_sale'
}

const mergeTuinaProjectListQuery = (reduxQuery) =>
  reduxQuery && Object.keys(reduxQuery).length > 0 ? reduxQuery : DEFAULT_TUINA_PROJECT_LIST_QUERY

const STATUS_TEXT = {
  on_sale: '上架',
  off_shelf: '下架'
}

class TuinaProjectsPage extends React.Component {
  didInitList = false

  componentDidMount () {
    this.props.fetchJStoreList({ query: {}, dataType: 'optionTuina' })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载门店列表失败'))
  }

  componentDidUpdate (prevProps) {
    if (this.didInitList) return
    if (this.props.getJStoreList.fetching) return
    if (!prevProps.getJStoreList.fetching) return
    this.didInitList = true
    const options = this.props.getJStoreList.data
    const first = Array.isArray(options) && options[0]
    const query = { ...DEFAULT_TUINA_PROJECT_LIST_QUERY }
    if (first && first.id != null && first.id !== '') query.storeId = first.id
    this.fetchList(query)
  }

  fetchList = (formatQuery) => {
    this.props
      .fetchTuinaProjectList({ query: formatQuery })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载服务项目失败'))
  }

  refreshList = () => {
    this.fetchList(mergeTuinaProjectListQuery(this.props.projectList.query))
  }

  handleTableChange = (pagination) => {
    const query = mergeTuinaProjectListQuery(this.props.projectList.query)
    this.fetchList({
      ...query,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    })
  }

  handleModalSuccess = () => {
    this.refreshList()
  }

  handleToggleStatus = async (record) => {
    const nextStatus = record.status === 'on_sale' ? 'off_shelf' : 'on_sale'
    try {
      await updateTuinaProjectStatus(record.id, { status: nextStatus })
    } catch (e) {
      return
    }
    message.success(nextStatus === 'on_sale' ? '已上架' : '已下架')
    this.refreshList()
  }

  getColumns = () => [
    {
      title: '封面',
      dataIndex: 'coverUrl',
      width: 160,
      render: (raw, record) => {
        const url = raw == null ? '' : String(raw).trim()
        const cover = url
          ? (
            <img
              className="tuina-project-cover"
              src={url}
              alt={record.name || ''}
            />
          )
          : <span className="tuina-project-cover is-empty" />
        return (
          <div className="tuina-project-cover-cell">
            {cover}
            {record.status === 'on_sale' ? (
              <Permission rootPath="tuinaPage">
                <span pathitem={['projects']} checkarray={['buttonCodes']}>
                  <PurchaseOrderModal record={record}>
                    <Button type="primary" size="large" aria-label={`下单 ${record.name}`}>下单</Button>
                  </PurchaseOrderModal>
                </span>
              </Permission>
            ) : null}
          </div>
        )
      }
    },
    {
      title: '名称',
      dataIndex: 'name',
      render: (v) => renderTextStr(v)
    },
    // {
    //   title: '服务描述',
    //   dataIndex: 'description',
    //   ellipsis: true,
    //   render: (v) => renderTextStr(v)
    // },
    {
      title: '时长',
      dataIndex: 'durationMinutes',
      width: 100,
      render: (v) => {
        const n = Number(v)
        if (v == null || v === '' || !Number.isFinite(n)) return renderTextStr('')
        return <span className="tuina-project-meta">{n}分钟</span>
      }
    },
    {
      title: '价格',
      dataIndex: 'price',
      width: 120,
      align: 'right',
      render: (v) => <span className="tuina-project-price">{renderMoney(v)}</span>
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 88,
      render: (v) => {
        const text = STATUS_TEXT[v] || v
        const color = v === 'on_sale' ? 'success' : 'default'
        if (!text) return renderTextStr(text)
        return <Tag color={color}>{text}</Tag>
      }
    },
    {
      title: '操作',
      key: 'actions',
      width: 168,
      render: (_, record) => {
        const isOnSale = record.status === 'on_sale'
        const actionText = isOnSale ? '下架' : '上架'
        return (
          <Permission rootPath="tuinaPage">
            <div pathitem={['projects']} checkarray={['buttonCodes']} className="tuina-project-actions">
              <ProjectModal actType="edit" record={record} onSuccess={this.handleModalSuccess}>
                <Button type="link" aria-label={`改 ${record.name}`}>编辑</Button>
              </ProjectModal>
              <Popconfirm
                title={`确认${actionText}该项目？`}
                description={record.name}
                okText={actionText}
                cancelText="取消"
                okButtonProps={{ danger: isOnSale, size: 'large' }}
                cancelButtonProps={{ size: 'large' }}
                onConfirm={() => this.handleToggleStatus(record)}
              >
                <Button type="link" danger={isOnSale} aria-label={`${actionText} ${record.name}`}>
                  {actionText}
                </Button>
              </Popconfirm>
            </div>
          </Permission>
        )
      }
    }
  ]

  render () {
    const { projectList, getJStoreList } = this.props
    const { fetching, query: reduxQuery, data } = projectList
    const query = mergeTuinaProjectListQuery(reduxQuery)
    const list = Array.isArray(data.list) ? data.list : []
    const totalRow = data.totalRow || 0
    const jStoreOptions = getJStoreList.data

    return (
      <div>
        <PageHeader title="服务项目" breadcrumbList={breadcrumbList} />
        <div className="i2-container">
          <Card className="i2-card-page">
            <section className="i2-app-toolbar tuina-project-toolbar">
              <div className="toolbar-filters">
                <SelectC
                  label="门店"
                  query={query}
                  searchKey="storeId"
                  options={jStoreOptions}
                  action={this.fetchList}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <Search
                  label="关键字"
                  query={query}
                  searchKey="keyword"
                  action={this.fetchList}
                  modalProps={{ allowClear: true, placeholder: '名称/编码' }}
                />
                <SelectC
                  label="状态"
                  query={query}
                  searchKey="status"
                  options={TUINA_PROJECT_STATUS_OPTIONS}
                  action={this.fetchList}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
              </div>
              <div className="toolbar-btns">
                <Permission rootPath="tuinaPage">
                  <span pathitem={['projects']} checkarray={['buttonCodes']}>
                    <ProjectModal actType="create" onSuccess={this.handleModalSuccess}>
                      <Button type="primary" size="large">新增</Button>
                    </ProjectModal>
                  </span>
                </Permission>
              </div>
            </section>
            <Table
              className="tuina-project-table"
              rowKey={(r) => String(r.id)}
              columns={this.getColumns()}
              dataSource={list}
              loading={fetching}
              onChange={this.handleTableChange}
              pagination={{
                current: query.pageNumber,
                pageSize: query.pageSize,
                total: totalRow,
                showSizeChanger: true,
                showTotal: (t) => `共 ${t} 条`,
                pageSizeOptions: ['10', '20', '50', '100']
              }}
            />
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  projectList: state.tuina.projectList,
  getJStoreList: state.components.getJStoreList
})

const mapDispatchToProps = {
  fetchTuinaProjectList,
  fetchJStoreList
}

export default connect(mapStateToProps, mapDispatchToProps)(TuinaProjectsPage)
